import { Grid, Typography } from "@mui/material";
import { brandingConstants } from "../../PreviewStyles/constants";
import { handleConvertPxToPt } from "../helpers";

interface IProps {
  product: any;
  productParams: any;
  branding: any;
  previewAgent: boolean;
}

const HeaderPreview = ({
  productParams = {},
  branding = {},
  previewAgent,
  product = {},
}: IProps) => {
  return (
    <Grid item container>
      <Grid item xs={10}>
        <Typography
          className="tv-feedback-main-title"
          sx={{
            color: branding?.[brandingConstants.mainTitleColor],
            fontWeight: branding?.[brandingConstants.mainTitleFontWeight],
            fontStyle: branding?.[brandingConstants.mainTitleFontStyle],
            fontFamily: branding?.[brandingConstants.mainTitleFontFamily],
            fontSize: handleConvertPxToPt(
              branding?.[brandingConstants.mainTitleFontSize],
              previewAgent
            ),
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            overflow: "hidden",
          }}
        >
          {product?.title}
        </Typography>
        <Typography
          className="tv-feedback-sub-title"
          sx={{
            color: branding?.[brandingConstants.subTitleColor],
            fontWeight: branding?.[brandingConstants.subTitleFontWeight],
            fontStyle: branding?.[brandingConstants.subTitleFontStyle],
            fontFamily: branding?.[brandingConstants.subTitleFontFamily],
            fontSize: handleConvertPxToPt(
              branding?.[brandingConstants.subTitleFontSize],
              previewAgent
            ),
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            overflow: "hidden",
          }}
        >
          {product?.subtitle}
        </Typography>
      </Grid>

      {productParams.productParams.products[0].feedbackAgentSettings
        .showLogo && productParams?.productParams?.products?.[0]?.logo && (
        <Grid xs={2} textAlign="right">
          <img
            src={productParams?.productParams?.products?.[0]?.logo}
            alt="logo"
            style={{ width: previewAgent ? "80px" : "60px" }}
          />
        </Grid>
      )}
    </Grid>
  );
};

export default HeaderPreview;
